import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithHidden, WithIsHome } from '~/core/styleTypes';
import { StrongName, WeakName } from '~/views/components/localizedTeamName/styles';
import { Situation } from '~/views/components/teamSituation/styles';

export const SIZING = {
    trapezoidHeight: 94,
    height: 96,
    stripe: 90,
    bigStripe: 108,
    trapezoid: 136,
    shapeMedium: 66,
    teamMarginLarge: 58,
    teamMarginExtraLarge: 38,
};

export const TeamContainer = styled.div<WithIsHome>`
    display: flex;
    justify-content: start;
    flex: 1;
    white-space: nowrap;
    z-index: 1;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.small};
        justify-content: center;
        ${({ $isHome }) => ($isHome ? 'margin-right' : 'margin-left')}: ${-1 * SIZING.shapeMedium}px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        justify-content: center;
        ${({ $isHome }) => ($isHome ? 'margin-right' : 'margin-left')}: ${-1 * SIZING.teamMarginLarge}px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        ${({ $isHome }) => ($isHome ? 'margin-right' : 'margin-left')}: ${-1 * SIZING.teamMarginExtraLarge}px;
    }
`;

export const TeamDisplayContainer = styled.div<WithIsHome>`
    ${BaseStyle.Mixins.gaps.small}

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 1;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: ${({ $isHome }) => ($isHome ? 'row-reverse' : 'row')};
        justify-content: initial;
        width: auto;
    }

    .team-display-container {
        flex: initial;
    }

    .team-display {
        justify-content: ${({ $isHome }) => ($isHome ? 'end' : 'initial')};

        img {
            height: 32px;
            width: 48px;

            ${BaseStyle.Mixins.screenSizes.medium} {
                height: 64px;
                width: 96px;
            }
        }
    }
`;

export const TeamNameContainer = styled.div<WithIsHome>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        align-items: ${({ $isHome }) => ($isHome ? 'end' : 'initial')};
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        width: 164px;
        margin-left: ${({ $isHome }) => ($isHome ? 'initial' : '16px')};
        margin-right: ${({ $isHome }) => ($isHome ? '16px' : 'initial')};
    }

    ${StrongName} {
        ${BaseStyle.Mixins.fontStyles.ui['20b']}

        ${BaseStyle.Mixins.screenSizes.small} {
            ${BaseStyle.Mixins.fontStyles.ui['16b']}
        }
    }

    ${WeakName} {
        ${BaseStyle.Mixins.fontStyles.ui['12m']}

        ${BaseStyle.Mixins.screenSizes.large} {
            ${BaseStyle.Mixins.fontStyles.ui['14m']}
        }
    }

    &:empty {
        display: none;
    }
`;

export const RecordText = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    color: ${({ theme }) => theme.Text.secondary};
    padding-top: 4px;
`;

export const ShotsAndSituationContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    ${BaseStyle.Mixins.fontStyles.ui['10m']}

    display: flex;
    align-items: center;
    margin-top: 4px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['12m']}
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['14m']}
    }

    ${Situation} {
        ${BaseStyle.Mixins.fontStyles.ui['10b']}

        ${BaseStyle.Mixins.screenSizes.medium} {
            ${BaseStyle.Mixins.fontStyles.ui['12b']}
        }

        ${BaseStyle.Mixins.screenSizes.large} {
            ${BaseStyle.Mixins.fontStyles.ui['14b']}
        }
    }
`;

export const ShotsOnGoal = styled.div<WithHidden>`
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'initial')};
    color: ${({ theme }) => theme.Text.secondary};
`;
